/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FinancialClassViewModel } from './financialClassViewModel';
import { FeeScheduleViewModel } from './feeScheduleViewModel';

export interface InsuranceCarrierViewModel {
  id?: string;
  datasetId?: string;
  carrierCode?: string | null;
  carrierName?: string | null;
  crossoverPayerId?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  stateCode?: string | null;
  zip?: string | null;
  countryCode?: string | null;
  phoneNumber?: string | null;
  holdBilling?: boolean;
  referringProviderRequired?: boolean;
  policyNumberRequired?: boolean;
  groupNumberRequired?: boolean;
  claimType?: string | null;
  secondaryClaimType?: string | null;
  carrierType?: string | null;
  payerId?: string | null;
  eligibilityPayerId?: string | null;
  chargeInsCode?: number;
  financialClassId?: string;
  financialClass?: FinancialClassViewModel;
  feeScheduleId?: string | null;
  feeSchedule?: FeeScheduleViewModel;
  procedureFeeScheduleId?: string | null;
  procedureFeeSchedule?: FeeScheduleViewModel;
  acceptAssignment?: boolean;
  sameRefund?: boolean;
  refundName?: string | null;
  refundAddress1?: string | null;
  refundAddress2?: string | null;
  refundCity?: string | null;
  refundStateCode?: string | null;
  refundZip?: string | null;
  refundCountryCode?: string | null;
  useDeptOfLaborProviderId?: boolean;
  inactive?: boolean;
  email?: string | null;
  paymentCodeId?: string | null;
  adjustmentCodeId?: string | null;
  adjustmentCode2Id?: string | null;
  interestCodeId?: string | null;
  defaultInsuranceTypeId?: string | null;
  excludeEligibility?: boolean;
  autoAdjustProcedures?: boolean;
  defaultFrequencyCodeId?: string | null;
}
